import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import './Layouts.css';
import {
  Breadcrumb, Icon, Tabs, Button, Steps, Skeleton, Empty, Switch, Radio, Col, Row, Rate, Slider,
  Form, DatePicker, TimePicker, Input, InputNumber, Select, Cascader, Checkbox, Upload,
} from 'antd';
import HeaderSection from '../../../../components/section/SectionHeader';
import PanelLayout from '../../../../components/panels/PanelLayout';
import routeLocations from '../../../../utility/route-locations';

const { TabPane } = Tabs;
const { Step } = Steps;
const { Option } = Select;

const operations = <Button type="primary">Extra Action</Button>;

function DeveloperPage({ form }) {
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
    },
  };
  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) { console.log('Received values of form: ', values); }
    });
  }, [form]);
  const normFile = useCallback((e) => {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  }, []);

  return (
    <section className="developer-page">
      <Row type="flex" justify="space-between" align="middle">
        <Breadcrumb separator=">" itemRender="">
          <Breadcrumb.Item>
            <Link className="app-standard-link" to={routeLocations.dashboard}><Icon type="home" /></Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link className="app-standard-link" to={routeLocations.developer}><FormattedMessage id="developer.short" /></Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item><FormattedMessage id="layouts.short" /></Breadcrumb.Item>
        </Breadcrumb>
      </Row>
      <PanelLayout titleId="layouts" titleLevel={2}>
        <Row type="flex" justify="end">
          <Link className="app-standard-link" to={routeLocations.developer_example} style={{ marginTop: '-3em' }}>
            <FormattedMessage id="goto" />
            &nbsp;
            <FormattedMessage id="example.short" />
          </Link>
        </Row>
        <HeaderSection titleId="Tabs" />
        <Tabs tabBarExtraContent={operations}>
          <TabPane tab="Tab 1" key="1">
            Content of tab 1
            <p>
              &nbsp;
            </p>
          </TabPane>
          <TabPane tab="Tab 2" key="2">
            Content of tab 2
          </TabPane>
          <TabPane tab="Tab 3" key="3">
            Content of tab 3
          </TabPane>
        </Tabs>

        <HeaderSection titleId="Getting Started" />
        <Steps>
          <Step status="finish" title="Login" icon={<Icon type="user" />} />
          <Step status="finish" title="Company Details" icon={<Icon type="shop" />} />
          <Step status="finish" title="Base Questions" icon={<Icon type="ordered-list" />} />
          <Step status="process" title="User Preferences" icon={<Icon type="sliders" />} />
          <Step status="wait" title="Ready to Inspect" icon={<Icon type="check-circle" />} />
        </Steps>
        <Skeleton />

        <HeaderSection titleId="Diagrams" />
        <Empty
          image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
          imageStyle={{ height: 60 }}
          description={(
            <span>
              <Link to="/dashboard">Empty area to be configured, e.g. vehicle diagrams</Link>
            </span>
          )}
        >
          <Button type="primary">Upload</Button>
        </Empty>

        <HeaderSection titleId="Forms" />
        <Form {...formItemLayout} onSubmit={e => handleSubmit(e)}>
          <Form.Item
            label="Fail"
            validateStatus="error"
            help="Should be combination of numbers & alphabets"
          >
            <Input placeholder="unavailable choice" id="error" />
          </Form.Item>

          <Form.Item label="Warning" validateStatus="warning">
            <Input placeholder="Warning" id="warning" />
          </Form.Item>

          <Form.Item
            label="Validating"
            hasFeedback
            validateStatus="validating"
            help="The information is being validated..."
          >
            <Input placeholder="I'm the content is being validated" id="validating" />
          </Form.Item>

          <Form.Item label="Success" hasFeedback validateStatus="success">
            <Input placeholder="I'm the content" id="success" />
          </Form.Item>

          <Form.Item label="Warning" hasFeedback validateStatus="warning">
            <Input placeholder="Warning" id="warning2" />
          </Form.Item>

          <Form.Item
            label="Fail"
            hasFeedback
            validateStatus="error"
            help="Should be combination of numbers & alphabets"
          >
            <Input placeholder="unavailable choice" id="error2" />
          </Form.Item>

          <Form.Item label="Success" hasFeedback validateStatus="success">
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item label="Warning" hasFeedback validateStatus="warning">
            <TimePicker style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item label="Error" hasFeedback validateStatus="error">
            <Select defaultValue="1">
              <Option value="1">Option 1</Option>
              <Option value="2">Option 2</Option>
              <Option value="3">Option 3</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Validating"
            hasFeedback
            validateStatus="validating"
            help="The information is being validated..."
          >
            <Cascader defaultValue={['1']} options={[]} />
          </Form.Item>

          <Form.Item label="inline" style={{ marginBottom: 0 }}>
            <Form.Item
              validateStatus="error"
              help="Please select the correct date"
              style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}
            >
              <DatePicker />
            </Form.Item>
            <span style={{ display: 'inline-block', width: '24px', textAlign: 'center' }}>-</span>
            <Form.Item style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
              <DatePicker />
            </Form.Item>
          </Form.Item>

          <Form.Item label="Success" hasFeedback validateStatus="success">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item label="Plain Text">
            <span className="ant-form-text">China</span>
          </Form.Item>
          <Form.Item label="Select" hasFeedback>
            {form.getFieldDecorator('select', {
              rules: [{ required: true, message: 'Please select your country!' }],
            })(
              <Select placeholder="Please select a country">
                <Option value="china">China</Option>
                <Option value="usa">U.S.A</Option>
              </Select>,
            )}
          </Form.Item>

          <Form.Item label="Select[multiple]">
            {form.getFieldDecorator('select-multiple', {
              rules: [
                { required: true, message: 'Please select your favourite colors!', type: 'array' },
              ],
            })(
              <Select mode="multiple" placeholder="Please select favourite colors">
                <Option value="red">Red</Option>
                <Option value="green">Green</Option>
                <Option value="blue">Blue</Option>
              </Select>,
            )}
          </Form.Item>

          <Form.Item label="InputNumber">
            {form.getFieldDecorator('input-number', { initialValue: 3 })(<InputNumber min={1} max={10} />)}
            <span className="ant-form-text"> machines</span>
          </Form.Item>

          <Form.Item label="Switch">
            {form.getFieldDecorator('switch', { valuePropName: 'checked' })(<Switch />)}
          </Form.Item>

          <Form.Item label="Slider">
            {form.getFieldDecorator('slider')(
              <Slider
                marks={{
                  0: 'A',
                  20: 'B',
                  40: 'C',
                  60: 'D',
                  80: 'E',
                  100: 'F',
                }}
              />,
            )}
          </Form.Item>

          <Form.Item label="Radio.Group">
            {form.getFieldDecorator('radio-group')(
              <Radio.Group>
                <Radio value="a">item 1</Radio>
                <Radio value="b">item 2</Radio>
                <Radio value="c">item 3</Radio>
              </Radio.Group>,
            )}
          </Form.Item>

          <Form.Item label="Radio.Button">
            {form.getFieldDecorator('radio-button')(
              <Radio.Group>
                <Radio.Button value="a">item 1</Radio.Button>
                <Radio.Button value="b">item 2</Radio.Button>
                <Radio.Button value="c">item 3</Radio.Button>
              </Radio.Group>,
            )}
          </Form.Item>

          <Form.Item label="Checkbox.Group">
            {form.getFieldDecorator('checkbox-group', {
              initialValue: ['A', 'B'],
            })(
              <Checkbox.Group style={{ width: '100%' }}>
                <Row>
                  <Col span={8}>
                    <Checkbox value="A">A</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox disabled value="B">
                      B
                    </Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="C">C</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="D">D</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="E">E</Checkbox>
                  </Col>
                </Row>
              </Checkbox.Group>,
            )}
          </Form.Item>

          <Form.Item label="Rate">
            {form.getFieldDecorator('rate', {
              initialValue: 3.5,
            })(<Rate />)}
          </Form.Item>

          <Form.Item label="Upload" extra="longgggggggggggggggggggggggggggggggggg">
            {form.getFieldDecorator('upload', {
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            })(
              <Upload name="logo" action="/upload.do" listType="picture">
                <Button>
                  <Icon type="upload" />
                  Click to upload
                </Button>
              </Upload>,
            )}
          </Form.Item>

          <Form.Item label="Dragger">
            <div className="dropbox">
              {form.getFieldDecorator('dragger', {
                valuePropName: 'fileList',
                getValueFromEvent: normFile,
              })(
                <Upload.Dragger name="files" action="/upload.do">
                  <p className="ant-upload-drag-icon">
                    <Icon type="inbox" />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                  <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                </Upload.Dragger>,
              )}
            </div>
          </Form.Item>

          <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>

        <HeaderSection titleId="Lists" />

        <HeaderSection titleId="Tables" />

        <HeaderSection titleId="Mobile" />

        <HeaderSection titleId="Drag & Drop" />

        <HeaderSection titleId="Translation" />

        <HeaderSection titleId="Notes" />


      </PanelLayout>
    </section>
  );
}

// Validate the prop type parameters.
DeveloperPage.propTypes = {
  form: PropTypes.shape({
    validateFields: PropTypes.func.isRequired,
    getFieldDecorator: PropTypes.func.isRequired,
  }).isRequired,
};

// Let antd automatically collect and validate data.
const Layouts = injectIntl(Form.create({})(DeveloperPage));

export default Layouts;
